import Login from "views/Login/Login.jsx";
import LockOpen from "@material-ui/icons/LockOpen";
import AssistantRegister from "views/Register/components/AssistantRegister.jsx";
import BrokerSignup from "views/Register/components/BrokerSignup.jsx";
import BrokerageSignup from "views/Register/components/BrokerageSignup.jsx";
import ForgotPassword from "views/Portal/ForgotPassword.jsx";
import ResetPassword from "views/Portal/ResetPassword.jsx";

const pagesRoutes = [
  {
    path: "/app/portal/login",
    name: "Login",
    short: "Login",
    mini: "L",
    icon: LockOpen,
    component: Login
  },
  {
    path: "/app/portal/signupbrokerage",
    name: "Signup as a Brokerage",
    short: "Register",
    mini: "R",
    icon: LockOpen,
    component: BrokerageSignup
  },
  {
    path: "/app/portal/signupbroker",
    name: "Signup as a Broker",
    short: "Register",
    mini: "R",
    icon: LockOpen,
    component: BrokerSignup
  },
  {
    path: "/app/portal/signupassistant",
    name: "Signup as an Assistant",
    short: "Register",
    mini: "R",
    icon: LockOpen,
    component: AssistantRegister
  },
  {
    path: "/app/portal/forgotpassword",
    name: "Forgot Password",
    short: "Forgot Password",
    mini: "FP",
    icon: LockOpen,
    component: ForgotPassword
  },
  {
    path: "/app/portal/resetpassword",
    name: "Reset Password",
    short: "Reset Password",
    mini: "RP",
    icon: LockOpen,
    component: ResetPassword
  }
];

export default pagesRoutes;



// WEBPACK FOOTER //
// ./src/routes/basicPages.jsx